import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {  Processinginfo } from 'src/app/model/RSS/BotStatus.model';

@Component({
  selector: 'app-rss-bot-status-details',
  templateUrl: './rss-bot-status-details.component.html',
  styleUrls: ['./rss-bot-status-details.component.css']
})
export class RssBotStatusDetailsComponent {
@Input() botStatus: Processinginfo;

constructor(
  @Inject(MAT_DIALOG_DATA) public data: Processinginfo
) {

  this.botStatus = data;
  console.log(this.botStatus);

}
}
